<script setup lang="ts">
import { defineProps } from "vue";
import { HourPersonalInfo } from "@/types/calculators";

defineProps<{
  personal: HourPersonalInfo;
}>();
</script>

<template>
  <div
    class="text-muted text-[11px]"
    v-if="
      personal.positive_markers.length === 0 &&
      personal.negative_markers.length === 0
    "
  >
    <span class="md:hidden">
      {{ $t("calculators.personal-date.full-day-report.hourlyTable.tenGods") }}
    </span>
    食神 / 正财
  </div>
  <div
    class="text-success font-medium text-[11px] flex flex-wrap gap-1"
    v-if="personal.positive_markers.length > 0"
  >
    <span v-for="(positive, index) in personal.positive_markers" :key="index">
      {{ positive }}
    </span>
  </div>
  <div
    class="text-error font-medium text-[11px] flex flex-wrap gap-1"
    v-if="personal.negative_markers.length > 0"
  >
    <span v-for="(negative, index) in personal.negative_markers" :key="index">
      {{ negative }}
    </span>
  </div>
</template>
